import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function HorariosBanner() {
  return <section className="py-16 bg-gold" data-id="element-187">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-188">
        <div className="flex items-center justify-center gap-3 mb-4" data-id="element-189">
          <Clock className="w-8 h-8 text-deepblack" data-id="element-190" />
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-deepblack" data-id="element-191">
            Estamos Abiertos Para Ti
          </h2>
        </div>
        <p className="text-deepblack text-xl font-semibold mb-2" data-id="element-192">
          Lunes a Domingo — Todos los días
        </p>
        <p className="text-deepblack text-2xl font-bold mb-2" data-id="element-193">
          8:30 AM — 9:30 PM
        </p>
        <p className="text-deepblack text-lg mb-8" data-id="element-194">
          Sin descanso. Sin excepciones.
        </p>
        <a href="https://wa.me/573028281216" target="_blank" rel="noopener noreferrer" className="inline-block bg-deepblack text-gold px-8 py-4 rounded-full font-bold text-lg hover:bg-black transition-all shadow-lg" data-id="element-195">
          💬 Reservar mi Cita Ahora
        </a>
      </motion.div>
    </section>;
}